import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

const TabPorPregunta = ({ preguntaRespuestaAgrupada }) => {
  return (
    <div className="row">
      {preguntaRespuestaAgrupada.map((preguntaItem, cardIndex) => {
        const totalFrases = preguntaItem.frases_seleccionadas?.length ?? 0;

        return (
          <motion.div
            key={cardIndex}
            className="col-lg-6 col-12 mb-20"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.1 + cardIndex * 0.08,
              duration: 0.4,
              ease: "easeOut",
            }}
          >
            <div className="card radius-12 h-100 cs-talent-card">
              <div className="card-body p-20">
                {/* ── Header ── */}
                <div className="cs-talent-header">
                  <div
                    className="d-flex align-items-start gap-2"
                    style={{ flex: 1, minWidth: 0 }}
                  >
                    <div className="cs-question-icon-wrap">
                      <Icon icon="mdi:help-circle-outline" />
                    </div>
                    <h4
                      className="cs-pregunta-title mb-0"
                      style={{ fontSize: "clamp(0.72rem, 1.8vw, 0.82rem)" }}
                    >
                      {preguntaItem.pregunta}
                    </h4>
                  </div>
                  <span className="cs-talent-badge" style={{ flexShrink: 0 }}>
                    {totalFrases}{" "}
                    {totalFrases === 1 ? "respuesta" : "respuestas"}
                  </span>
                </div>

                {/* ── Lista de frases con talento ── */}
                {totalFrases > 0 ? (
                  <div className="cs-frases-list cs-frases-scroll">
                    {preguntaItem.frases_seleccionadas.map((item, fIndex) => (
                      <motion.div
                        key={fIndex}
                        className="cs-frase-agrupada-item"
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                          delay: 0.1 + cardIndex * 0.08 + fIndex * 0.05,
                          duration: 0.26,
                        }}
                      >
                        <span className="cs-frase-agrupada-text">
                          {item.frase}
                        </span>
                        <span className="cs-talento-chip">{item.talento}</span>
                      </motion.div>
                    ))}
                  </div>
                ) : (
                  <div className="cs-empty-state">
                    <Icon icon="mdi:minus-circle-outline" />
                    <span>Sin respuestas en esta pregunta</span>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default TabPorPregunta;
